export class CoverProductSelectionDTO {
    constructor(
        public productSkuId: string,
        public modifierSkuIds: string[],
        public menuItemId: string | null = null,
    ) {}
}

export class CoverMenuChoiceDTO {
    constructor(
        public name: string | null,
        public notes: string | null,
        public selections: CoverProductSelectionDTO[]
    ) {}
}

export class BookingDocketDTO {
    constructor(
        public id: string,
        public menuId: string,
        public coverChoices: CoverMenuChoiceDTO[],
        public dateCreated: string,
        public dateUpdated: string,
        public minimumCoursesRequired: number | null = null,
        public maximumCoursesRequired: number | null = null
    ) {}
}
